/* eslint-disable react/display-name */
import classNames from 'classnames'
import React, { forwardRef } from 'react'

type Props = {
  transparent?: boolean
  children: React.ReactNode
}

const Header = forwardRef<HTMLElement, Props>(
  ({ children, transparent }, ref) => {
    return (
      <header
        className={classNames({
          Header: true,
          'Header--Transparent': transparent
        })}
        ref={ref}
      >
        {children}
      </header>
    )
  }
)

export default Header
